import type { User } from "firebase/auth";

/** Existing access is carried by the signed token; only legacy accounts migrate. */
export async function garantirAcessoProduto(
  usuario: Pick<User, 'getIdTokenResult'>,
  migrar: () => Promise<unknown>,
): Promise<void> {
  const token = await usuario.getIdTokenResult();
  if (token.claims.acessoProduto === true) return;
  await migrar();
  const atualizado = await usuario.getIdTokenResult(true);
  if (atualizado.claims.acessoProduto !== true) {
    throw new Error('A permissão de acesso ainda não está disponível.');
  }
}
